// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "9932c28f" + "." + "bb7481fd93c36094" + ".js";
};